
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.75 3a.75.75 0 00-1.5 0v1.25h-6.5V3a.75.75 0 00-1.5 0v1.25H6A2.75 2.75 0 003.25 7v12A2.75 2.75 0 006 21.75h12A2.75 2.75 0 0020.75 19V7A2.75 2.75 0 0018 4.25h-1.25V3zm2.5 7.25V7c0-.69-.56-1.25-1.25-1.25h-1.25V7a.75.75 0 01-1.5 0V5.75h-6.5V7a.75.75 0 01-1.5 0V5.75H6c-.69 0-1.25.56-1.25 1.25v3.25h14.5zm-14.5 1.5h14.5V19c0 .69-.56 1.25-1.25 1.25H6c-.69 0-1.25-.56-1.25-1.25v-7.25zM7.25 15a.75.75 0 01.75-.75h2a.75.75 0 01.75.75v2a.75.75 0 01-.75.75H8a.75.75 0 01-.75-.75v-2z"}})])
          )
        }
      }
    